import { useMemo } from 'react'
import { useGetTaskTypeQuery, RTK_QUERY_OPTIONS } from 'apiv2'
import { TASK_TYPE } from 'utils/constants'
import { COLORS, SUBTASK_BADGE, SUBBUG_BADGE } from './constants'
import { StyledType } from './styled'

const TaskTypeBadge = ({ taskType, variant, subtaskFlag = false }) => {
  const { data: taskTypes } = useGetTaskTypeQuery(
    undefined,
    RTK_QUERY_OPTIONS.DISABLE_REFETCH_ON_FOCUS
  )
  const isSubtask = subtaskFlag && taskType?.id === TASK_TYPE.Task
  const isSubbug = subtaskFlag && taskType?.id === TASK_TYPE.Bug
  const typeName = taskType?.name ?? taskType?.label

  const typeConfig = useMemo(
    () => taskTypes?.find((task) => task.name === typeName),
    [taskTypes, typeName]
  )

  const badge = useMemo(() => {
    if (isSubtask) {
      return SUBTASK_BADGE
    }

    if (isSubbug) {
      return SUBBUG_BADGE
    }

    return {
      name: typeName,
      bgColor: typeConfig?.bgColor,
      color: typeConfig?.color,
    }
  }, [isSubtask, isSubbug, typeName, typeConfig])

  const dark = COLORS[badge.color]

  return (
    <StyledType
      data-variant={variant}
      style={{
        '--tt-fg-light': badge.color,
        '--tt-fg-dark': dark,
        '--tt-bg': badge.bgColor,
      }}
    >
      {badge.name}
    </StyledType>
  )
}

export default TaskTypeBadge
